var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3232 2.5C10.9365 2.50011 11.4881 2.87398 11.7158 3.44336L12.916 6.44336C13.0248 6.71557 13.0456 6.99392 13 7.25488V12C13 12.5523 12.5523 13 12 13H4C3.44777 12.9999 3 12.5522 3 12V7.25488C2.9544 6.99394 2.97523 6.71555 3.08398 6.44336L4.28418 3.44336C4.51193 2.87399 5.06355 2.50016 5.67676 2.5H10.3232ZM8 6.90039C7.66871 6.90048 7.40039 7.16869 7.40039 7.5V10.0527L6.42383 9.07617C6.18951 8.84195 5.81046 8.84191 5.57617 9.07617C5.34197 9.31046 5.34197 9.68954 5.57617 9.92383L7.57617 11.9238C7.68865 12.0363 7.84094 12.0996 8 12.0996C8.15907 12.0996 8.31133 12.0363 8.42383 11.9238L10.4238 9.92383C10.6581 9.68952 10.6581 9.31048 10.4238 9.07617C10.1895 8.84195 9.81046 8.84191 9.57617 9.07617L8.59961 10.0527V7.5C8.59961 7.16864 8.33135 6.90041 8 6.90039ZM5.67676 3.5C5.47246 3.50016 5.28877 3.62474 5.21289 3.81445L4.33887 6H11.6611L10.7871 3.81445C10.7112 3.62473 10.5276 3.50011 10.3232 3.5H5.67676Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.3e85b0cf0e3622a6326ed8a883eac1f7.svg";
export { ForwardRef as ReactComponent };